




































import ffButton from '@/components/public/Button.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: {
    ffButton
  }
})
export default class HistoryItem extends Vue {
  loading = false
  @Prop({
    type: String,
    default: '',
    required: true
  })
  name!: string
  @Prop({
    type: Number,
    default: '',
    required: false
  })
  time!: number
  @Prop({
    type: Number,
    default: 3,
    required: false
  })
  status!: number
  @Prop({
    type: Number,
    default: 0,
    required: false
  })
  size!: number
  @Prop({
    type: String,
    default: '',
    required: false
  })
  url!: string
  @Prop({
    type: Number,
    default: '',
    required: false
  })
  recordId!: number
  
  classFormat (status: number): string {
    switch (status) {
      case 0:
      case 3:
        return 'waiting'
      default:
        return ''
    }
  }
  timeFormat (time: number): string {
    const date = new Date(time * 1000)
    const [secs, mins, hours, day, month, year ] = [
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds(),
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
      date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
      date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
      date.getMonth() + 1 < 10 ? '0' + (date.getMonth()+1) : date.getMonth()+1,
      date.getFullYear()
    ]
    return `${year}.${month}.${day} ${hours}:${mins}:${secs}`
  }
  sizeFormat (size: number): string {
    return (size / 1024).toFixed(1) + 'KB'
  }
  onCopy () {
    this['$notify']({
      title: 'success',
      message: 'Copy success',
      type: 'success',
      offset: 80
    })
  }
  onError () {
    this['$notify'].error({
      title: 'Failed',
      message: `Copy failed`,
      offset: 80
    })
  }
  refresh () {
    this.loading = true
    this['$api'].get(`/get?record_id=${this.recordId}`).then((res: object) => {
      const data = res['data']
      this.loading = false
      this.$emit('modify-status', data['record'].status, this.recordId)
    })
  }
}
